import * as t from "io-ts";
import { PropertiesDataV } from "./tree";

export const ElementPresetV = t.type({
  id: t.string,
  name: t.string,
  availableForType: t.string,
  design: PropertiesDataV
});

export type ElementPreset = t.TypeOf<typeof ElementPresetV>;

export const ElementPresetsV = t.array(ElementPresetV);

export type ElementPresets = t.TypeOf<typeof ElementPresetsV>;
